export const enum amsCompletedStatus {
  ApplicationReceived = 'Application Received',
  OrderCancelledAtCorrectiveActionRequired = 'Order Cancelled at Corrective Action Required',
  OfferDeclinedandApplicationClosed = 'Offer Declined and Application Closed',
  ApplicationCancellationRequestedbyCustomer = 'Application Cancellation Requested by Customer',
  ClosingOrderatProposedCreate = 'Closing Order at Proposed Create',
  SiteAccessNotRequired = 'Site Access Not Required',
  SiteAccessNotRequiredandOrderClosed = 'Site Access Not Required and Order Closed',
  ColocationInitiated = 'Colocation Initiated',
  UpgradeColocationInitiated = 'Upgrade Colocation Initiated',
  ApplicationRequiresCorrectiveAction = 'Application Requires Corrective Action',
  AmendApplicationSelected = 'Amend Application Selected',
  ApplicationFeeApplied = 'Application Fee Applied',
  DetailedDesignRequired = 'Detailed Design Required',
  DetailedDesignRequiresCorrectiveAction = 'Detailed Design Requires Corrective Action',
  RecurringBillingEstablished = 'Recurring Billing Established',
  SiteAccessRequired = 'Site Access Required',
  SiteAccessRequestRequiresCorrectiveAction = 'Site Access Request Requires Corrective Action',
  SiteAccessRequestApproved = 'Site Access Request Approved',
  InstallationCompleted = 'Installation Completed',
  AsBuiltDocumentsRequireCorrectiveAction = 'As-Built Documents Require Corrective Action',
  InboundColocationCompleted = 'Inbound Colocation Completed',
  UpgradeColocationCompleted = 'Upgrade Colocation Completed',
  InitialAssessmentSubmitted = 'Initial Assessment Submitted',
  InitialAssessmentAcceptedByColoCoordinator = 'Initial Assessment Accepted By Colo Coordinator',
  UpgradeOfferRequired = 'Upgrade Offer Required',
  ProjectAssetsConfirmed = 'Project Assets Confirmed',
  OfferSubmitted = 'Offer Submitted',
  OfferRejectedByCommercialManagement = 'Offer Rejected By Commercial Management',
  OfferSent = 'Offer Sent',
  OfferDeclinedandAmendmentRequested = 'Offer Declined and Amendment Requested',
  OrderCancelledatUpgradeOffer = 'Order Cancelled at Upgrade Offer',
  UpgradeOfferSubmitted = 'Upgrade Offer Submitted',
  OfferAcceptedbyCustomer = 'Offer Accepted by Customer',
  DetailedDesignNotRequired = 'Detailed Design Not Required',
  DetailedDesignSubmitted = 'Detailed Design Submitted',
  DetailedDesignApproved = 'Detailed Design Approved',
  BillingUpdatesRequired = 'Billing Updates Required',
  BillingUpdatesNotRequired = 'Billing Updates Not Required',
  BillingUpdatesCompleted = 'Billing Updates Completed',
  SiteAccessRequestSubmitted = 'Site Access Request Submitted',
  AsBuiltDocumentsSubmitted = 'As-Built Documents Submitted',
  OrderCancelled = 'Order Cancelled',
  ReservationCancelledByCustomer = 'Reservation Cancelled by Customer',
  ApplicationCancelledBasedOnAssessment = 'Application Cancelled Based on Assessment',
  OfferDeclinedAndApplicationClosed = 'Offer Declined and Application Closed',
  SiteAccessNotRequiredAndOrderClosed = 'Site Access Not Required and Order Closed',
  UpgradeOfferNotRequired = 'Upgrade Offer Not Required',
  CancellationPendingColoCoordinatorReview = 'Cancellation Pending Colo Coordinator Review',
  ProjectCancelled ='Project Cancelled',
  TerminateColocationCompleted = 'Terminate Colocation Completed',
  TerminateColocationCompletedDuetoNonCompliance ='Terminate Colocation Completed Due to Non-Compliance',
  OrderCancelledatTerminationOffer = 'Order Cancelled at Termination Offer'
}

export const fileValidExt: string[] = [
  'AVI',
  'XLS',
  'XLSX',
  'CSV',
  'DOC',
  'DOCX',
  'ZIP',
  'TXT',
  'DWG',
  'EML',
  'FLV',
  'GIF',
  'JPEG',
  'JPG',
  'MOV',
  'MP4',
  'MPEG',
  'MPG',
  'MSG',
  'PDF',
  'PNG',
  'PPT',
  'PPTX',
  'TIF',
  'XML',
];
export const mulipleFileValidExt: string[] = [
  "AVI",
  "XLS",
  "XLSX",
  "CSV",
  "DOC",
  "DOCX",
  "PDF",
  "JPEG",
  "JPG",
  "PNG",
  "PPT",
  "PPTX",
  "ZIP",
  "TXT",
  "EML",
  "MSG",
  "DWG",
  "FLV",
  "GIF",
  "MOV",
  "MP4",
  "MPEG",
  "MPG",
  "TIF",
  "XML"
]

export const photoValidExt: string[] = ['JPEG', 'JPG', 'PNG', 'ZIP'];

export const summaryColoButtonList = [
  {
    name: 'Submit Order',
    status: [
      amsCompletedStatus.ColocationInitiated,
      amsCompletedStatus.UpgradeColocationInitiated,
      amsCompletedStatus.AmendApplicationSelected,
    ],
    tabName: 'cudetails',
    className: 'next',
  },
  {
    name: 'Update Order',
    status: [amsCompletedStatus.ApplicationRequiresCorrectiveAction],
    tabName: '',
    className: 'next',
  },
  {
    name: 'Cancel Order',
    status: [
      amsCompletedStatus.ColocationInitiated,
      amsCompletedStatus.UpgradeColocationInitiated,
      amsCompletedStatus.ApplicationRequiresCorrectiveAction,
      amsCompletedStatus.AmendApplicationSelected,
      amsCompletedStatus.ApplicationFeeApplied,
      amsCompletedStatus.DetailedDesignRequired,
      amsCompletedStatus.DetailedDesignRequiresCorrectiveAction,
    ],
    tabName: '',
    className: 'cancel',
  },
  {
    name: 'Close Order',
    status: [
      amsCompletedStatus.RecurringBillingEstablished,
      amsCompletedStatus.SiteAccessRequired,
      amsCompletedStatus.SiteAccessRequestRequiresCorrectiveAction,
    ],
    tabName: '',
    className: 'cancel',
  },
  {
    name: 'Design & Construction Proposal',
    status: [
      amsCompletedStatus.ApplicationFeeApplied,
      amsCompletedStatus.DetailedDesignRequired,
      amsCompletedStatus.DetailedDesignRequiresCorrectiveAction,
    ],
    tabName: 'detailed',
    className: 'next',
  },
  {
    name: 'Construction Access Order',
    status: [
      amsCompletedStatus.RecurringBillingEstablished,
      amsCompletedStatus.SiteAccessRequired,
      amsCompletedStatus.SiteAccessRequestRequiresCorrectiveAction,
    ],
    tabName: 'siteaccess',
    className: 'next',
  },
  {
    name: 'Practical Completion Advice',
    status: [amsCompletedStatus.SiteAccessRequestApproved],
    tabName: 'install',
    className: 'next',
  },
  {
    name: 'As-Built Documents',
    status: [
      amsCompletedStatus.InstallationCompleted,
      amsCompletedStatus.AsBuiltDocumentsRequireCorrectiveAction,
    ],
    tabName: 'builts',
    className: 'next',
  },
  {
    name: 'View Order Details',
    status: [
      amsCompletedStatus.InboundColocationCompleted,
      amsCompletedStatus.UpgradeColocationCompleted,
      amsCompletedStatus.ApplicationCancelledBasedOnAssessment,
      amsCompletedStatus.OrderCancelledatUpgradeOffer,
      amsCompletedStatus.OfferDeclinedAndApplicationClosed,
      amsCompletedStatus.SiteAccessNotRequiredAndOrderClosed,
      amsCompletedStatus.OrderCancelled,
      amsCompletedStatus.OrderCancelledAtCorrectiveActionRequired,
      amsCompletedStatus.ApplicationCancellationRequestedbyCustomer,
      amsCompletedStatus.SiteAccessNotRequired,
      amsCompletedStatus.ClosingOrderatProposedCreate,
      amsCompletedStatus.ReservationCancelledByCustomer,
      amsCompletedStatus.CancellationPendingColoCoordinatorReview,
      // amsCompletedStatus.ProjectCancelled,
      amsCompletedStatus.InitialAssessmentSubmitted,
      amsCompletedStatus.InitialAssessmentAcceptedByColoCoordinator,
      amsCompletedStatus.UpgradeOfferRequired,
      amsCompletedStatus.ProjectAssetsConfirmed,
      amsCompletedStatus.OfferSubmitted,
      amsCompletedStatus.OfferRejectedByCommercialManagement,
      amsCompletedStatus.OfferSent,
      amsCompletedStatus.OfferDeclinedandAmendmentRequested,
      amsCompletedStatus.UpgradeOfferNotRequired,
      amsCompletedStatus.UpgradeOfferSubmitted,
      amsCompletedStatus.OfferAcceptedbyCustomer,
      amsCompletedStatus.ApplicationFeeApplied,
      amsCompletedStatus.DetailedDesignNotRequired,
      amsCompletedStatus.DetailedDesignSubmitted,
      amsCompletedStatus.DetailedDesignApproved,
      amsCompletedStatus.BillingUpdatesRequired,
      amsCompletedStatus.BillingUpdatesNotRequired,
      amsCompletedStatus.BillingUpdatesCompleted,
      amsCompletedStatus.SiteAccessRequestSubmitted,
      amsCompletedStatus.AsBuiltDocumentsSubmitted,
      amsCompletedStatus.ApplicationReceived,
    ],
    tabName: 'cudetails',
    className: 'next',
  },
];

export const summaryColoOutcomeList = [
  {
    key: 'L2OutcomeOfReview',
    status: [
      amsCompletedStatus.ApplicationRequiresCorrectiveAction,
      amsCompletedStatus.AmendApplicationSelected,
      amsCompletedStatus.ApplicationFeeApplied,
      amsCompletedStatus.DetailedDesignRequired,
    ],
  },
  {
    key: 'L3OutcomeOfReview',
    status: [
      amsCompletedStatus.DetailedDesignRequiresCorrectiveAction,
      amsCompletedStatus.RecurringBillingEstablished,
      amsCompletedStatus.SiteAccessRequired,
    ],
  },
  {
    key: 'L5OutcomeOfReview',
    status: [
      amsCompletedStatus.SiteAccessRequestRequiresCorrectiveAction,
      amsCompletedStatus.SiteAccessRequestApproved,
    ],
  },
  {
    key: 'L6OutcomeOfReview',
    status: [amsCompletedStatus.AsBuiltDocumentsRequireCorrectiveAction],
  },
];

export const summaryColoInProgressStatus = [
  amsCompletedStatus.InitialAssessmentSubmitted,
  amsCompletedStatus.InitialAssessmentAcceptedByColoCoordinator,
  amsCompletedStatus.UpgradeOfferRequired,
  amsCompletedStatus.ProjectAssetsConfirmed,
  amsCompletedStatus.OfferSubmitted,
  amsCompletedStatus.OfferRejectedByCommercialManagement,
  amsCompletedStatus.OfferSent,
  amsCompletedStatus.OfferDeclinedandAmendmentRequested,
  amsCompletedStatus.UpgradeOfferNotRequired,
  amsCompletedStatus.UpgradeOfferSubmitted,
  amsCompletedStatus.OfferAcceptedbyCustomer,
  amsCompletedStatus.DetailedDesignNotRequired,
  amsCompletedStatus.DetailedDesignSubmitted,
  amsCompletedStatus.DetailedDesignApproved,
  amsCompletedStatus.BillingUpdatesRequired,
  amsCompletedStatus.BillingUpdatesNotRequired,
  amsCompletedStatus.BillingUpdatesCompleted,
  amsCompletedStatus.SiteAccessRequestSubmitted,
  amsCompletedStatus.AsBuiltDocumentsSubmitted,
  amsCompletedStatus.ApplicationReceived,
];

export const completeAMSStatus = [
  amsCompletedStatus.InstallationCompleted,
  amsCompletedStatus.AsBuiltDocumentsRequireCorrectiveAction,
  amsCompletedStatus.UpgradeColocationCompleted,
  amsCompletedStatus.InboundColocationCompleted,
  amsCompletedStatus.AsBuiltDocumentsSubmitted
];

export const l3AMSStatus = [
  amsCompletedStatus.ColocationInitiated,
  amsCompletedStatus.UpgradeColocationInitiated,
  amsCompletedStatus.ApplicationRequiresCorrectiveAction,
  amsCompletedStatus.AmendApplicationSelected,
  amsCompletedStatus.ApplicationCancelledBasedOnAssessment,
  amsCompletedStatus.OrderCancelledAtCorrectiveActionRequired,
  amsCompletedStatus.OrderCancelledatUpgradeOffer,
  amsCompletedStatus.OfferDeclinedandApplicationClosed,
];
export const l5AMSStatus = [
  ...l3AMSStatus,
  amsCompletedStatus.ApplicationFeeApplied,
  amsCompletedStatus.DetailedDesignRequired,
  amsCompletedStatus.ApplicationCancellationRequestedbyCustomer,
  amsCompletedStatus.DetailedDesignRequiresCorrectiveAction,
  amsCompletedStatus.ClosingOrderatProposedCreate,
  amsCompletedStatus.SiteAccessNotRequired,  
  amsCompletedStatus.OrderCancelled,
  amsCompletedStatus.ReservationCancelledByCustomer,
  amsCompletedStatus.DetailedDesignSubmitted,
  amsCompletedStatus.DetailedDesignApproved,
  amsCompletedStatus.BillingUpdatesRequired,
  amsCompletedStatus.BillingUpdatesNotRequired,
  amsCompletedStatus.BillingUpdatesCompleted,
];
export const l5AAMSStatus = [
  ...l5AMSStatus,
  amsCompletedStatus.RecurringBillingEstablished,
  amsCompletedStatus.SiteAccessRequired,
  amsCompletedStatus.SiteAccessNotRequiredandOrderClosed,
  amsCompletedStatus.SiteAccessRequestRequiresCorrectiveAction,
  amsCompletedStatus.SiteAccessRequestSubmitted,
];
export const l6AMSStatus = [
  ...l5AAMSStatus,
  amsCompletedStatus.SiteAccessRequestApproved,
];

export const managedByCompanyTab = [
 amsCompletedStatus.ClosingOrderatProposedCreate,
 amsCompletedStatus.InboundColocationCompleted,
amsCompletedStatus.ReservationCancelledByCustomer,
amsCompletedStatus.OfferDeclinedAndApplicationClosed,
amsCompletedStatus.ApplicationCancelledBasedOnAssessment,
amsCompletedStatus.ProjectCancelled,
amsCompletedStatus.SiteAccessNotRequiredandOrderClosed,
amsCompletedStatus.SiteAccessNotRequired,
amsCompletedStatus.UpgradeColocationCompleted,
amsCompletedStatus.OrderCancelledAtCorrectiveActionRequired,
amsCompletedStatus.OrderCancelledatUpgradeOffer,
amsCompletedStatus.OrderCancelled,
amsCompletedStatus.TerminateColocationCompleted,
amsCompletedStatus.TerminateColocationCompletedDuetoNonCompliance,
amsCompletedStatus.OrderCancelledatTerminationOffer,
]

export const strdescMap: { [key: string]: string } = {
  GREEN: 'Likely Capacity For Colocation',
  AMBER: 'Recommend Engineering Assessment For Colocation',
  BLUE: 'Tower Strengthening In Progress, Submit Enquiry',
  RED: 'Tower Undergoing Major Works, Submit Enquiry',
  GREY: 'Structural Capacity Information Not Available',
};
